import io from 'socket.io-client';

export default class Socket {

  isActive = false;
  pullInterval = null;
  pullTimeout = null;
	
  constructor(callbacks) {
    this.callbacks = callbacks || [];
    this.socket = null;
  }

  setActive(state) {
    this.isActive = state;
    if (state) {
      this.pullTimeout && clearTimeout(this.pullTimeout);
      this.pullTimeout = setTimeout(() => {
        this.socket && this.socket.close();
        this.isActive = false;
      }, 120 * 1000);
    }
  }

  pullLoop = () => {
    this.pullInterval && clearInterval(this.pullInterval);
    if (this.socket && this.isActive)
      this.socket.emit('pull');
    this.pullInterval = setInterval(() => {
      if (!this.isActive) return;
      this.socket && this.socket.emit('pull');
    }, 15000);
  }

  connect = (socketServer, uid) => {
    this.socketServer = socketServer;
    this.socket = io.connect(this.socketServer, { timeout: 5000, query: { uid } });
    this.socket.onAny((event, ...args) => {
      const reg = this.callbacks.find(e => e.event === event);
      if (reg)
        reg.func(args[0]);
    });
    this.socket.on("connect", this.onConnected);
  };

  onConnected = () => {
    if (this.socket) {
      console.log('socket WS connected');
      setTimeout(() => {
        this.pullLoop();
      }, 1000);
    }
  };

  disconnect = () => {
    if (this.socket) {
      this.socket.close();
      this.pullInterval && clearInterval(this.pullInterval);
    }
  };
}
